import { render, staticRenderFns } from "./_ContentArea.vue?vue&type=template&id=700f9a00&scoped=true&"
import script from "./_ContentArea.vue?vue&type=script&lang=js&"
export * from "./_ContentArea.vue?vue&type=script&lang=js&"
import style0 from "./_ContentArea.vue?vue&type=style&index=0&id=700f9a00&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700f9a00",
  null
  
)

export default component.exports